import React from 'react';

const Vue_deactivated = () => {
  return (
    <div>
      <h1>Vue_deactivated Component</h1>
      <p>This is the Vue_deactivated tutorial page.</p>
    </div>
  );
}

export default Vue_deactivated;
